import React, { useEffect } from "react";
import CheckMarkIcon from "../../assets/CheckMarkIcon";

interface CustomAlertProps {
  message: string;
  visible?: boolean;
  onClose?: () => void;
}

const CustomAlert: React.FC<CustomAlertProps> = ({
  message,
  visible,
  onClose,
}) => {
  useEffect(() => {
    if (visible) {
      const timer = setTimeout(() => {
        if (onClose) {
          onClose();
        }
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [visible, onClose]);

  if (!visible) return null;

  return (
    <div className="text-BCP-dark-gray flex items-end space-x-2 text-[12px] py-2.5 px-3 rounded-lg font-[400] bg-BCP-light-green inline-flex">
      <CheckMarkIcon />
      <span>{message}</span>
      <button
        onClick={onClose}
        className="ml-2 text-BCP-dark-gray hover:text-BCP-blue"
        aria-label="Close alert"
      >
        ✕
      </button>
    </div>
  );
};

export default CustomAlert;
